import { XIcon } from "lucide-react";
import React from "react";
import { FaSms, FaWhatsapp } from "react-icons/fa";


interface StatusBadgeProps {
  status: "draft" | "active" | "inactive" | "archived" | "published";
}

export const StatusBadge: React.FC<StatusBadgeProps> = ({ status }) => (
  <span className={`inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium ${
    status === "active" ? "bg-green-100 dark:bg-green-500/15 text-green-700 dark:text-green-400" : "bg-yellow-100 dark:bg-yellow-500/15 text-yellow-700 dark:text-yellow-400"
  }`}>
    <span className={`w-1.5 h-1.5 rounded-full ${status === "active" ? "bg-green-500" : "bg-yellow-500"}`} />
    {status}
  </span>
);


interface ChannelBadgeProps {
  channel: "whatsapp" | "sms" | "rcs" | "email" | string;
}

const CHANNEL_STYLE: Record<string, { bg: string; label: string }> = {
  whatsapp: { bg: "bg-[#28D748]", label: "WhatsApp" },
  sms:      { bg: "bg-[#28D748]", label: "SMS" },
  rcs:      { bg: "bg-indigo-600", label: "RCS" },
  email:    { bg: "bg-rose-500",   label: "Email" },
};

export const ChannelBadge: React.FC<ChannelBadgeProps> = ({ channel }) => {
  const style = CHANNEL_STYLE[channel] || CHANNEL_STYLE.whatsapp;
  let Icon: React.ReactNode = <FaWhatsapp />;
  if (channel === "sms") Icon = <FaSms />;
  else if (channel === "rcs") Icon = <span className="text-[10px] font-bold">RCS</span>;
  else if (channel === "email") Icon = <span className="text-[10px] font-bold">EM</span>;
  return (
    <div className={`w-8 h-8 rounded-lg flex items-center text-white justify-center ${style.bg}`}>
      {Icon}
    </div>
  );
};



interface FilterChipProps {
  label: string;
  onRemove: () => void;
}

export const FilterChip: React.FC<FilterChipProps> = ({ label, onRemove }) => (
  <span className="inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium bg-indigo-50 dark:bg-indigo-500/15 text-indigo-700 dark:text-indigo-400 border border-indigo-200 dark:border-indigo-500/30">
    {label}
    <button onClick={onRemove} className="hover:text-indigo-900 dark:hover:text-indigo-200 transition-colors">
      <XIcon />
    </button>
  </span>
);



interface TagPillProps {
  label: string;
  onRemove: () => void;
}

export const TagPill: React.FC<TagPillProps> = ({ label, onRemove }) => (
  <span className={`inline-flex items-center gap-1 px-2 py-1 rounded-md text-xs font-medium border ${
    label === "High-value Customers"
      ? "bg-green-50 dark:bg-green-500/10 border-green-300 dark:border-green-500/30 text-green-700 dark:text-green-400"
      : "bg-yellow-50 dark:bg-yellow-500/10 border-yellow-300 dark:border-yellow-500/30 text-yellow-700 dark:text-yellow-400"
  }`}>
    {label}
    <button onClick={onRemove} className="ml-0.5 hover:opacity-70">
      <XIcon />
    </button>
  </span>
);